import http from 'hub-http/clients/apiClient';
import { getFullUrl } from 'hubspot-url-utils';
import Raven from 'raven-js';
export const fetchActiveTrials = () => {
  return http.get(`${getFullUrl('app-api')}/trials/v1/hub-trials?active=true`).catch(error => {
    Raven.captureException(new Error('Failed to fetch active trials'), {
      extra: {
        error
      }
    });
    throw error;
  });
};